/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const campaignMetaAdDataSchema = z.object({
	startDate: z.iso.datetime().nullable(),
	endDate: z.iso.datetime().nullable(),
})

export type CampaignMetaAdDataSchema = z.infer<typeof campaignMetaAdDataSchema>
